"use strict";

const NavbarPort = {
  add: (app) => {
    const tt = document.createElement("span");
    tt.className = "sidenav-fixed-tooltip";
    document.body.appendChild(tt);
    let scrolling = false,
      scrollTimer;
    document.addEventListener(
      "pointerenter",
      ({ target, pointerType }) => {
        if (pointerType !== "mouse") return;
        const w = target.closest?.(".sidenav__main--desktop .tooltip-wrapper");
        const t = w?.querySelector(".tooltip[data-text]");
        if (!t || scrolling) return;
        const r = w.getBoundingClientRect();
        Object.assign(tt, { textContent: t.dataset.text });
        Object.assign(tt.style, {
          display: "block",
          top: `${r.top + (r.height - tt.offsetHeight) / 2}px`,
          left: `${r.right + 10}px`,
        });
      },
      true,
    );
    document.addEventListener(
      "pointerleave",
      ({ target, pointerType }) => {
        if (pointerType !== "mouse") return;
        if (target.closest?.(".sidenav__main--desktop .tooltip-wrapper"))
          tt.style.display = "none";
      },
      true,
    );
    document.addEventListener(
      "scroll",
      ({ target }) => {
        if (!target.closest?.(".sidenav__main--desktop")) return;
        scrolling = true;
        tt.style.display = "none";
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          scrolling = false;
        }, 100);
      },
      true,
    );

    app.ports.sidenavLinkClickedPort.subscribe(() => {
      app.ports.onSidenavLinkClickedPort.send(null);
    });

    const overlay = document.createElement("div");
    overlay.className = "sidenav-overlay";
    document.body.appendChild(overlay);

    new MutationObserver(() => {
      const isOpen = !!document.querySelector(".sidenav--slide-in");
      overlay.classList.toggle("sidenav-overlay--visible", isOpen);

      if (isOpen) {
        requestAnimationFrame(() => {
          const mobileNav = document.querySelector(".sidenav__main--mobile");
          const activeItem = mobileNav?.querySelector(".sidenav__active");
          if (mobileNav && activeItem) {
            activeItem.scrollIntoView({ block: "nearest", behavior: "smooth" });
          }
        });
      }
    }).observe(document.body, { attributeFilter: ["class"], subtree: true });

    overlay.addEventListener("click", () => {
      document.querySelector(".sidenav-close button")?.click();
    });

    window.addEventListener("outsideHinterViewUpdated", function (customEvent) {
      app.ports.sidenavHinterViewUpdatedPort.send(
        customEvent.detail["hinterViewOff"],
      );
    });

    app.ports.topnavHeaderHeightChangedPort.subscribe((headerHeight) => {
      const root = document.documentElement;

      root.style.setProperty("--total-header-height", headerHeight + "px");

      // On mobile, the sidebar slides in from the top, covering the topnav.
      // Those 55px need to be accounted for when adjusting the wrapper's margin.
      const mobileNavHeight = window.innerWidth <= 768 ? getTopnavHeight() : 0;
      root.style.setProperty("--mobile-nav-height", mobileNavHeight + "px");
    });

    if (app.ports.globalSearchButtonClickedPort) {
      app.ports.globalSearchButtonClickedPort.subscribe(() => {
        const event = new Event("outsideGlobalSearchTriggered");
        window.dispatchEvent(event);
      });
    }

    const getTopnavHeight = () => {
      const style = getComputedStyle(document.documentElement).getPropertyValue(
        "--topnav-height",
      );
      return parseInt(style.replace("px", "").trim());
    };
  },
};

module.exports = NavbarPort;
